// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.progress-text {
  font-size: 15px;
  width: 100%;
  margin-top: 75px;
  text-align: center;
  height: 25px;
  overflow: hidden;
}
.progress-slide-container {
  width: 209px;
}
.progress-slide-line {
  width: 100%;
  height: 0px;
  border-bottom: 2px solid rgba(112, 112, 112, 1);
  opacity: 1;
  margin-top: 10px;
  margin-left: 52px;
}
.progress-slide-circle {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  opacity: 1;
  position: absolute;
  left: 100px;
  bottom: 16px;
}
.previous-chapter {
  width: 25px !important;
  height: 25px !important;
  border-radius: 50%;
  opacity: 1;
  font-size: 15px;
  transform: rotate(90deg);
  cursor: pointer;
}
.next-chapter {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  opacity: 1;
  font-size: 15px;
  transform: rotate(-90deg);
  cursor: pointer;
}

.previous-chapter-icon {
  line-height: 27px !important;
  margin-left: 5px !important;
}
.next-chapter-icon {
  line-height: 27px !important;
  margin-left: 5px !important;
}
input[type="range"] {
  -webkit-appearance: none;
  width: 200px;
  background: transparent;
}
input[type="range"]::-webkit-slider-thumb {
  -webkit-appearance: none;
}
input[type="range"]::-webkit-slider-runnable-track {
  width: 200px;
  height: 0px;
  border-bottom: 2px solid rgba(112, 112, 112, 1);
  opacity: 1;
  cursor: pointer;
  background: transparent;
}
input[type="range"]::-moz-range-track {
  width: 200px;
  height: 0px;
  border-bottom: 2px solid rgba(112, 112, 112, 1);
  opacity: 1;
  cursor: pointer;
  background: transparent;
}
input[type="range"]::-ms-track {
  width: 200px;
  height: 0px;
  border-bottom: 2px solid rgba(112, 112, 112, 1);
  opacity: 1;
  cursor: pointer;
  background: transparent;
  border-color: transparent;
  color: transparent;
}
input[type="range"]:focus {
  outline: none;
}
input[type="range"]::-webkit-slider-thumb {
  width: 20px;
  height: 20px;
  border: 2px solid rgba(112, 112, 112, 1);
  border-radius: 50%;
  opacity: 1;
  position: relative;
  bottom: 9px;
  cursor: pointer;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 1);
}

input[type="range"]::-moz-range-thumb {
  width: 20px;
  height: 20px;
  border: 2px solid rgba(112, 112, 112, 1);
  border-radius: 50%;
  opacity: 1;
  position: relative;
  bottom: 9px;
  cursor: pointer;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 1);
}

input[type="range"]::-ms-thumb {
  width: 20px;
  height: 20px;
  border: 2px solid rgba(112, 112, 112, 1);
  border-radius: 50%;
  opacity: 1;
  position: relative;
  bottom: 9px;
  cursor: pointer;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 1);
}
.progress-panel {
  width: 450px !important;
  height: 100px;
  opacity: 1;
  position: absolute;
  bottom: 0px;
  left: calc(50% - 225px);
  z-index: 10;
  animation: fade-up 0.1s ease-in-out 0s 1;
}

#jumpPage,
#jumpChapter {
  width: 30px;
  border: none;
  height: 20px;
  border-radius: 5px;
  padding-left: 10px;
  margin-right: 5px;
  margin-left: 5px;
}
#jumpPage,
#jumpChapter {
  outline: none;
}
`, "",{"version":3,"sources":["webpack://./src/containers/panels/progressPanel/progressPanel.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,WAAW;EACX,+CAA+C;EAC/C,UAAU;EACV,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;EACE,wBAAwB;EACxB,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,WAAW;EACX,+CAA+C;EAC/C,UAAU;EACV,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,WAAW;EACX,+CAA+C;EAC/C,UAAU;EACV,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,WAAW;EACX,+CAA+C;EAC/C,UAAU;EACV,eAAe;EACf,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,kCAAkC;AACpC;AACA;EACE,uBAAuB;EACvB,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,WAAW;EACX,wCAAwC;AAC1C;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;EAEE,aAAa;AACf","sourcesContent":[".progress-text {\n  font-size: 15px;\n  width: 100%;\n  margin-top: 75px;\n  text-align: center;\n  height: 25px;\n  overflow: hidden;\n}\n.progress-slide-container {\n  width: 209px;\n}\n.progress-slide-line {\n  width: 100%;\n  height: 0px;\n  border-bottom: 2px solid rgba(112, 112, 112, 1);\n  opacity: 1;\n  margin-top: 10px;\n  margin-left: 52px;\n}\n.progress-slide-circle {\n  width: 15px;\n  height: 15px;\n  border-radius: 50%;\n  opacity: 1;\n  position: absolute;\n  left: 100px;\n  bottom: 16px;\n}\n.previous-chapter {\n  width: 25px !important;\n  height: 25px !important;\n  border-radius: 50%;\n  opacity: 1;\n  font-size: 15px;\n  transform: rotate(90deg);\n  cursor: pointer;\n}\n.next-chapter {\n  width: 25px;\n  height: 25px;\n  border-radius: 50%;\n  opacity: 1;\n  font-size: 15px;\n  transform: rotate(-90deg);\n  cursor: pointer;\n}\n\n.previous-chapter-icon {\n  line-height: 27px !important;\n  margin-left: 5px !important;\n}\n.next-chapter-icon {\n  line-height: 27px !important;\n  margin-left: 5px !important;\n}\ninput[type=\"range\"] {\n  -webkit-appearance: none;\n  width: 200px;\n  background: transparent;\n}\ninput[type=\"range\"]::-webkit-slider-thumb {\n  -webkit-appearance: none;\n}\ninput[type=\"range\"]::-webkit-slider-runnable-track {\n  width: 200px;\n  height: 0px;\n  border-bottom: 2px solid rgba(112, 112, 112, 1);\n  opacity: 1;\n  cursor: pointer;\n  background: transparent;\n}\ninput[type=\"range\"]::-moz-range-track {\n  width: 200px;\n  height: 0px;\n  border-bottom: 2px solid rgba(112, 112, 112, 1);\n  opacity: 1;\n  cursor: pointer;\n  background: transparent;\n}\ninput[type=\"range\"]::-ms-track {\n  width: 200px;\n  height: 0px;\n  border-bottom: 2px solid rgba(112, 112, 112, 1);\n  opacity: 1;\n  cursor: pointer;\n  background: transparent;\n  border-color: transparent;\n  color: transparent;\n}\ninput[type=\"range\"]:focus {\n  outline: none;\n}\ninput[type=\"range\"]::-webkit-slider-thumb {\n  width: 20px;\n  height: 20px;\n  border: 2px solid rgba(112, 112, 112, 1);\n  border-radius: 50%;\n  opacity: 1;\n  position: relative;\n  bottom: 9px;\n  cursor: pointer;\n  box-sizing: border-box;\n  background: rgba(255, 255, 255, 1);\n}\n\ninput[type=\"range\"]::-moz-range-thumb {\n  width: 20px;\n  height: 20px;\n  border: 2px solid rgba(112, 112, 112, 1);\n  border-radius: 50%;\n  opacity: 1;\n  position: relative;\n  bottom: 9px;\n  cursor: pointer;\n  box-sizing: border-box;\n  background: rgba(255, 255, 255, 1);\n}\n\ninput[type=\"range\"]::-ms-thumb {\n  width: 20px;\n  height: 20px;\n  border: 2px solid rgba(112, 112, 112, 1);\n  border-radius: 50%;\n  opacity: 1;\n  position: relative;\n  bottom: 9px;\n  cursor: pointer;\n  box-sizing: border-box;\n  background: rgba(255, 255, 255, 1);\n}\n.progress-panel {\n  width: 450px !important;\n  height: 100px;\n  opacity: 1;\n  position: absolute;\n  bottom: 0px;\n  left: calc(50% - 225px);\n  z-index: 10;\n  animation: fade-up 0.1s ease-in-out 0s 1;\n}\n\n#jumpPage,\n#jumpChapter {\n  width: 30px;\n  border: none;\n  height: 20px;\n  border-radius: 5px;\n  padding-left: 10px;\n  margin-right: 5px;\n  margin-left: 5px;\n}\n#jumpPage,\n#jumpChapter {\n  outline: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
